export const INIT_DIALOG = "INIT_DIALOG";
export const OPEN_DIALOG = "OPEN_DIALOG";
export const CLOSE_DIALOG = "CLOSE_DIALOG";
export const TOGGLE_DIALOG = "TOGGLE_DIALOG";

export const initDialog = (dialogId, active) => {
	return {
		type: INIT_DIALOG,
		dialogId,
		active
	};
};

export const openDialog = (dialogId, event) => {
	return {
		type: OPEN_DIALOG,
		dialogId,
		event
	};
};

export const closeDialog = dialogId => {
	return {
		type: CLOSE_DIALOG,
		dialogId
	};
};

export const toggleDialog = dialogId => {
	return {
		type: TOGGLE_DIALOG,
		dialogId
	};
};
